import React, { useContext } from 'react';

import './FocusedFencers.css';
import '../../styles/colors.css';

import localize from '../../i18n/localize';
import LocalizedContext from '../../i18n/LocalizedContext';

const FocusedFencers = props => {
    const focusedFencers = [...props.focusedFencers];
    const fencerHandler = props.fencerHandler;

    const lang = useContext(LocalizedContext);

    const tdFocused = data => 
        data ? 
            <td className='FocusedFencers'>
                <span className='FocusedFencers' onClick={ () => fencerHandler(data) }>{data}</span>
            </td> : '';

    if(focusedFencers.length === 0) return '';

    while( focusedFencers.length % 2 !== 0 ) focusedFencers.push('');
    const rows = [];
    for (let i = 0; i < focusedFencers.length; i += 2) {
        rows.push(
            <tr key={i}>
                {tdFocused(focusedFencers[i])}
                {tdFocused(focusedFencers[i+1])}
            </tr>
        );
    }

    const tableInfo = focusedFencers.length === 0 ? '' : localize(lang, 'focusedOpponentsInfo');

    return (
        <div className='FocusedFencers-description'>
            {tableInfo}
            <center>
                <table>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </center>
        </div>
    );
}

export default FocusedFencers;